const url = `${process.env.REACT_APP_BASEURL}/api/admin/subscriptions`;

export const getSubscriptionListApi = async ({ page = 1, limit = 10, search = "" } = {}) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        action: "get",
        page,
        limit,
        search
      })
    });

    if (!response.ok) {
      throw new Error("Failed to fetch subscription list. Please try again.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching subscription list:", error);
  }
};

export default { getSubscriptionListApi };
